import superagent from '@ott/superagent';
import checkAjaxError from '@ott/helper-check-ajax-error';

import { createAsyncThunk } from '@reduxjs/toolkit';
import { Payload, ResponseSuccess } from './types';
import { AuthError, SuperagentError } from '../../types';
import { successEvent, userNotFoundEvent } from '../../helpers/events';

export const forgotPassword = createAsyncThunk<
  ResponseSuccess,
  Payload,
  { rejectValue: AuthError }
>('auth/forgotPassword', async ({ email, reqHost = '' }, { dispatch, rejectWithValue }) => {
  const url = `${reqHost}/_auth/authenticate/recover-password`;
  try {
    const {
      body: { error },
      status,
    } = await superagent.post(url).type('form').send({ email }).withCredentials();

    if (error) {
      rejectWithValue({ data: error, status });
    }

    successEvent('Auth_Popup_ForgotPwd_Restore_Click');

    return { success: true };
  } catch (e) {
    const err = e as SuperagentError;

    if ('response' in err) {
      userNotFoundEvent('Auth_Popup_ForgotPwd_Restore_Click');

      return rejectWithValue({ data: checkAjaxError(e) });
    }

    return rejectWithValue({});
  }
});
